"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandType = void 0;
var CommandType;
(function (CommandType) {
    CommandType["Start"] = "START";
    CommandType["End"] = "END";
    CommandType["Measure"] = "MEASURE";
    CommandType["BPMChange"] = "BPMCHANGE";
    CommandType["Delay"] = "DELAY";
    CommandType["Scroll"] = "SCROLL";
    CommandType["GoGoStart"] = "GOGOSTART";
    CommandType["GoGoEnd"] = "GOGOEND";
    CommandType["BarLineOff"] = "BARLINEOFF";
    CommandType["BarLineOn"] = "BARLINEON";
    CommandType["BranchStart"] = "BRANCHSTART";
    CommandType["BranchEnd"] = "BRANCHEND";
    CommandType["Section"] = "SECTION";
    CommandType["Lyric"] = "LYRIC";
    CommandType["LevelHold"] = "LEVELHOLD";
    CommandType["BMScroll"] = "BMSCROLL";
    CommandType["HBScroll"] = "HBSCROLL";
    CommandType["SENoteChange"] = "SENOTECHANGE";
    CommandType["NextSong"] = "NEXTSONG";
    CommandType["Direction"] = "DIRECTION";
    CommandType["Sudden"] = "SUDDEN";
    CommandType["JPosScroll"] = "JSPOSSCROLL";
    CommandType["BranchMarker"] = "__BRANCHMARKER";
    CommandType["NoteSequence"] = "__NOTESEQUENCE";
})(CommandType = exports.CommandType || (exports.CommandType = {}));
